import { render, staticRenderFns } from "./ArticleDirectoryList.vue?vue&type=template&id=1c42904e&scoped=true&"
import script from "./ArticleDirectoryList.vue?vue&type=script&lang=js&"
export * from "./ArticleDirectoryList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDirectoryList.vue?vue&type=style&index=0&id=1c42904e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c42904e",
  null
  
)

export default component.exports